import classNames from "classnames";
import * as React from "react";
import styles from "./index.module.css";
import type { CustomArrowProps } from "react-slick";

type Props = {
  type: string;
};

export const SliderArrow: React.FC<CustomArrowProps & Props> = ({
  onClick,
  type,
}) => {
  return (
    <div
      className={classNames(styles.slideArrow, {
        [styles.slideArrowPrev]: type === "prev",
        [styles.slideArrowNext]: type === "next",
      })}
      onClick={onClick}
    >
      <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle
          cx="16"
          cy="16"
          r="15.5"
          transform="rotate(180 16 16)"
          fill="white"
          fillOpacity="0.3"
          stroke="white"
        />
        <path
          d="M13.5584 16.0329L18.3136 11.2767C18.4329 11.1578 18.5276 11.0165 18.5922 10.8609C18.6568 10.7053 18.6901 10.5385 18.6901 10.37C18.6901 10.2016 18.6568 10.0347 18.5922 9.87916C18.5276 9.72357 18.4329 9.58227 18.3136 9.46335L18.2378 9.38868C18.1189 9.26935 17.9776 9.17467 17.822 9.11007C17.6664 9.04546 17.4996 9.01221 17.3312 9.01221C17.1627 9.01221 16.9959 9.04546 16.8403 9.11007C16.6847 9.17467 16.5434 9.26935 16.4245 9.38868L10.7498 15.0634C10.7317 15.0815 10.7168 15.1007 10.6997 15.1188L10.6912 15.1273C10.5718 15.2463 10.4772 15.3876 10.4126 15.5432C10.348 15.6987 10.3147 15.8656 10.3147 16.034C10.3147 16.2025 10.348 16.3693 10.4126 16.5249C10.4772 16.6805 10.5718 16.8218 10.6912 16.9407L16.4096 22.658C16.5285 22.7773 16.6698 22.872 16.8254 22.9366C16.981 23.0012 17.1478 23.0345 17.3162 23.0345C17.4847 23.0345 17.6515 23.0012 17.8071 22.9366C17.9627 22.872 18.104 22.7773 18.2229 22.658L18.2976 22.5823C18.4169 22.4634 18.5116 22.3221 18.5762 22.1665C18.6408 22.0109 18.674 21.8441 18.674 21.6756C18.674 21.5071 18.6408 21.3403 18.5762 21.1848C18.5116 21.0292 18.4169 20.8879 18.2976 20.7689L13.5584 16.0329Z"
          fill="white"
        />
      </svg>
    </div>
  );
};

export default SliderArrow;
